export default function DynamicFeaturesSection({
  heading,
  description,
  dynamicFeatures = [],
}) {
  return (
    <section className="w-full bg-[#FFFFFF] py-10 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center max-w-5xl mx-auto">
          {heading && (
            <h2 className="text-xl leading-7.5 sm:text-3xl font-roboto font-bold text-[#16324F]">
              {heading}
            </h2>
          )}
          {description && (
            <p className="mt-3 text-sm leading-6 sm:text-base text-[#10324F] px-2 font-roboto  text-center max-w-3xl mx-auto">
              {description}
            </p>
          )}
        </div>

        {/* Cards */}
        <div className="mt-8 sm:mt-12 grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {dynamicFeatures.map((item) => (
            <div
              key={item.id}
              style={{
                boxShadow: `
                  rgb(167 191 210 / 30%) -15px -15px 20px inset,
                  rgb(170 188 202 / 20%) -20px -20px 30px
                `,
              }}
              // style={{
              //   boxShadow: `rgb(167 191 210 / 8%) -15px -15px 20px inset, rgb(170 188 202 / 15%) -20px -20px 30px`,
              // }}
              className="bg-white rounded-xl shadow-sm border border-[#E4ECF3] p-4 sm:p-6 flex gap-3 items-start"
            >
              {/* Number Box */}
              <div className="min-w-8.5 h-8.5 rounded-md bg-[#16324F] font-roboto text-white flex items-center justify-center text-sm font-bold shadow">
                {item.id}
              </div>

              {/* Content */}
              <div>
                <h2 className="font-roboto text-sm sm:text-base font-semibold text-[#10324F] leading-5">
                  {item.title}
                </h2>

                <p className="mt-1 font-roboto text-xs sm:text-sm leading-5 text-[#10324F]">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
